module.exports = __webpack_public_path__ + "img/Pacific cushion seastar.a639f4b8.png";